import { AGENT_USER_ID, PLATE_BOT_NAME, PLATE_BOT_AVATAR } from '@/const/constants'
import { getMemberDisplayName } from '@/utils/memberDisplayName'
import type { WorkspaceMember } from '@/contexts/WorkspaceContext'
import type { ActivityEvent } from '@/store/activity/activitySlice'

const AGENT_AVATAR_COLOR = '#6366f1'

export interface ActivityActorDisplay {
    displayName: string
    avatarColor: string
    avatarImage: string | null
}

// Resolve the actor shown for an activity event. Identity comes from `actorId` (who authorized),
// NOT from `source`: app, MCP, and OAuth-API writes all carry the acting user, so they show that
// user — only a plain X-API-Key write (no user → actorId is null) falls back to the agent (Plate).
// The built-in agent's own actions (actorId === AGENT_USER_ID) also show as the agent.
export function getActivityActorDisplay(
    event: Pick<ActivityEvent, 'actorId'>,
    getMember: (id: string) => WorkspaceMember | undefined,
): ActivityActorDisplay {
    if (!event.actorId || event.actorId === AGENT_USER_ID) {
        return { displayName: PLATE_BOT_NAME, avatarColor: AGENT_AVATAR_COLOR, avatarImage: PLATE_BOT_AVATAR }
    }
    const member = getMember(event.actorId)
    return {
        displayName: member ? getMemberDisplayName(member) : 'Deleted user',
        avatarColor: member?.color ?? '#888',
        avatarImage: member?.avatarImage ?? null,
    }
}
